import React, { useState } from 'react';
import { isNil, map } from 'lodash-es';
import './Category.scss';
import Lottie from 'lottie-react';
import { useGetCategoryByIdQuery } from '../../store/menu/menuApi';
import loader from '../../assets/lotties/loader.json';
import { IGetMenuItemResponse } from '../../proto/menu/item/menuItem';
import { MenuItem } from '../MenuItem/MenuItem';
import { Item } from '../../Item/Item';
import { ICreateOrderItemFromMenuItemRequest } from '../../proto/order/orderItem';
import { useAddItemToCartMutation } from '../../store/cart/cartApi';

interface ICategoryProps {
	menuId: string;
	categoryId: string;
}

export const Category = ({ menuId, categoryId }: ICategoryProps): JSX.Element => {
	const { data: category, isLoading } = useGetCategoryByIdQuery({ menuId, categoryId }, { skip: !categoryId });
	const [selectedItemId, setSelectedItemId] = useState<string>(null);
	const [addItemToCart] = useAddItemToCartMutation();

	const handleItemDismiss = (): void => {
		setSelectedItemId(null);
	};

	const handleItemSubmit = (orderItem: ICreateOrderItemFromMenuItemRequest): void => {
		handleItemDismiss();
		addItemToCart({ item: orderItem });
		setSelectedItemId(null);
	};

	const handleItemClick = (itemId: string): void => {
		setSelectedItemId(itemId);
	};

	return (
		<>
			{isLoading ? (
				<Lottie animationData={loader} loop style={{ width: '10rem' }} />
			) : (
				<div className="categoryContainer">
					<div className="menuItemsList">
						{map(category?.items, (item: IGetMenuItemResponse) => (
							<MenuItem key={item.id} item={item} onClick={(): void => handleItemClick(item.id)} />
						))}
					</div>
				</div>
			)}
			{!isNil(selectedItemId) && <Item menuItemId={selectedItemId} onDismiss={handleItemDismiss} onSubmit={handleItemSubmit} />}
		</>
	);
};
